import * as React from "react";

export type MathEditorState = Readonly<{
    openKeypadID: string | null;

    isAnyActive: boolean;

    sendMessage: () => void;
}>;

/**
 * Context that keeps track of the current external state of the MathEditor.
 */
export const MathEditorContext: React.Context<MathEditorState> =
    React.createContext<MathEditorState>({
        openKeypadID: null,
        isAnyActive: false,
        sendMessage: () => {},
    });

export type MathEditorAPI = Readonly<{
    setOpenKeypadID: (openKeypadID: string | null) => void;

    setActiveInputs: React.Dispatch<
        React.SetStateAction<Record<string, boolean>>
    >;

    setSendMessage: (sendMessage: () => void) => void;
}>;

/**
 * Context providing an API for updating the external state of the MathEditor.
 */
export const MathEditorAPIContext: React.Context<MathEditorAPI> =
    React.createContext<MathEditorAPI>({
        setOpenKeypadID: () => {},
        setActiveInputs: () => {},
        setSendMessage: () => {},
    });
